import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  glow?: boolean;
}
export function Card({
  children,
  className = '',
  glow = false,
  ...props
}: CardProps) {
  return <div className={`
        relative overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900/50 p-6
        ${glow ? 'shadow-[0_0_40px_-10px_rgba(37,99,235,0.15)] border-blue-900/30' : ''}
        ${className}
      `} {...props} data-id="element-4">
      {glow && <div className="absolute -top-20 -right-20 h-40 w-40 rounded-full bg-blue-600/10 blur-3xl pointer-events-none" data-id="element-5" />}
      {children}
    </div>;
}